import { AnalyticsPageBlueprints } from "hooks/useAnalytics/pages/blueprints";

export const ANALYTICS = {
  analyticsPage: AnalyticsPageBlueprints.BlueprintTemplateBody,
};
